<template>
  <el-dialog
    id="department-dialog-component"
    :close-on-click-modal="false"
    :title="departmentDialogTitle"
    :visible.sync="departmentDialog"
    :before-close="closeDepartmentDialog"
    width="800px"
  >
    <div class="department-content">
      <div class="select-container">
        <div class="department-list">
          <TreeCheckout
            :companyList="departmentList"
            :departmentId="departmentId"
            :selectDepartment="selectDepartment"
            :isFlag="isFlag"
            :selectData="selectData"
            @selectTreeNodeList="selectDepartmentHeadTreeNodeList"
          />
        </div>
      </div>
      <div class="border"></div>
      <div class="selected-container">
        <p class="label">已选：</p>
        <div class="selected-content">
          <ul class="selected-list">
            <li
              class="selected-item"
              v-for="(value, index) in selectData"
              :key="index"
            >
              <span class="selected-item-name">
                <img :src="second" class="second">
                {{ value.departmentName }}
              </span>
              <span class="remove" @click="removeSelectData(index)">移除</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDepartmentDialog">取 消</el-button>
      <el-button type="primary" @click="submitDepartmentDialog"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import TreeCheckout from "@/components/tree/tree-checkout.vue";
import { mapId2, mapChildThirdDisable, mapChildFourDisable } from "@/common/js/utils.js";
import { getAministerLevel } from "@/common/js/storage.js";
import Staff from "@/models/staff.js";
export default {
  props: {
    departmentDialogTitle: {
      type: String,
      default: "请选择部门",
    },
    departmentDialog: {
      type: Boolean,
      default: false,
    },
    isFlag: {
      type: Number,
      default: 2
    },
    /* 模块唯一标识*/
    keyword: {
      type: String,
      default: 'reimburse'
    }
  },
  components: {
    TreeCheckout
  },
  data() {
    return {
      selectDepartment: false,
      second: require('../assets/tree/second.png'),
      searchDepartment: "",
      selectData: [],
      departmentList: [],
      departmentId: 0,
      isFlag2: this.isFlag,
      // 获取3级部门id
      parentId: '',
      // 可以选择哪一级
      isLevel: '',
      timerId: null
    };
  },
  created() {
    this.isLevel = getAministerLevel()
    if (this.keyword != 'property') this.initRoleTypeDepartment()
    if (this.keyword == 'property') this.getDepartmentList()
  },
  mounted () {
    this.$bus.on('init', v => {
      this.isFlag2 = v
      if (this.keyword != 'property') this.initRoleTypeDepartment()
      if (this.keyword == 'property') this.getDepartmentList()
    })
    this.$bus.on('initSelectDepartment', v => {
      this.selectData = v
      if (v.length > 0) {
        let arr = this.treeFindPath(this.departmentList, node => node.id === this.selectData[0].id)
        this.parentId = arr[2]
      }
    })
  },
  beforeDestroy() {
    clearTimeout(this.timerId)
  },
  methods: {
    /* 某角色的管理范围内的组织信息 */
    initRoleTypeDepartment() {
      let keyword = this.keyword;
      Staff.getModuleManagerDepartmentList(keyword).then((res) => {
        if (res.success) {
          let arr
          if(this.isLevel == 3 || this.isFlag2 == 1) {
            arr = mapChildThirdDisable(res.result);
          }
          if(this.isLevel == 4 && this.isFlag2 != 1)  arr = mapChildFourDisable(res.result);
          this.departmentList = mapId2(arr, this.departmentId)
          this.$bus.emit('initLeafKeys', this.departmentList)
        } else {
          this.$message.error(res.message);
        }
      })
    },

    mapChildDisable(child, id) {
      let arr = [];
      child.map((value) => {
        let obj = {};
        if (value.zzdCode) {
          obj.id = `${value.zzdCode}|${value.deptId}`
        } else {
          obj.id = value.id;
        }
        obj.id2 = value.id
        obj.teamId = id
        obj.zzdCode = value.zzdCode
        obj.departmentName = value.name;
        obj.image = value.image;
        obj.level = value.level;
        obj.parentId = value.parentId;
        obj.parentName = value.parentName;
        obj.departmentNum = value.totalNum;
        obj.departmentHead = value.head;
        obj.jurisdictionHead = value.leader;
        obj.disabled = true
        if (value.level == 4) obj.disabled = false
        if (value.subList && value.subList.length > 0) {
          obj.subList = this.mapChildDisable(value.subList, value.parentId);
        } else {
          obj.subList = [];
        }
        arr.push(obj);
      });
      return arr;
    },

    /* 获取部门数据 */
    getDepartmentList() {
      let searchDepartment = ''
      let id = ''
      let keyword = this.keyword
      Staff.getChangeDepartmentList(id, searchDepartment, keyword).then(res => {
        if (res.success) {
          let arr
          if(this.isLevel == 3 || this.isFlag2 == 1) {
            arr = mapChildThirdDisable(res.result);
          } else {
            arr = mapChildFourDisable(res.result);
          }
          this.departmentList = arr
          this.$bus.emit('initLeafKeys', this.departmentList)
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },
    treeFindPath (tree, func, path = []) {
      if (!tree) return []
      for (const data of tree) {
        path.push(data.id)
        if (func(data)) return path
        if (data.subList) {
          const findChildren = this.treeFindPath(data.subList, func, path)
          if (findChildren.length) return findChildren
        }
        path.pop()
      }
      return []
    },

    /* 移除 */
    removeSelectData(index) {
      this.selectData.splice(index, 1);
      this.$bus.emit('del', this.selectData)
    },

    /* 关闭弹窗 */
    closeDepartmentDialog() {
      this.searchDepartment = "";
      this.selectData = [];
      this.$emit("oPenOrCloseDepartmentDialog", false);
    },

    /* 确定弹窗 */
    submitDepartmentDialog() {
      if (this.selectData.length > 0) {
        this.$emit("submitSelectData", this.selectData);
      }
    },

    selectDepartmentHeadTreeNodeList(v) {
      let isFlag = false
      v.map(i => {
        if (this.selectData.length > 0 && this.parentId != i.parentId) {
          isFlag = true
        } else {
          if (i.level == 3) this.parentId = i.id
          if (i.level != 3) this.parentId = i.parentId
        }
      })
      if (isFlag) {
        let arr = []
        this.selectData.map(i => {
          arr.push(i.id)
        })
        this.timerId = setTimeout(() => {
          this.$bus.emit('clear', arr)
        },100)
        return this.$message.error('一个审批流程只适用于一个三级部门')
      }
      this.selectData = v
    }
  },
};
</script>
<style lang='scss'>
#department-dialog-component {
  .el-dialog__body {
    position: relative;
  }
  .department-content {
    margin: 16px 20px;
    border: 1px solid $bg-ShallowLightSnow;
    display: flex;
    justify-content: space-between;
    overflow-y: auto;
    overflow-x: hidden;
    height: 350px;
    box-sizing: border-box;
    .border {
      position: absolute;
      top: 0px;
      left: 50%;
      height: 350px;
      transform: translateX(-50%);
      width: 1px;
      background: $bg-ShallowLightSnow;
    }
    .select-container {
      width: 49%;
      .department-list {
        padding: 12px;
        box-sizing: border-box;
      }
    }
    .selected-container {
      width: 49%;
      padding: 12px;
      box-sizing: border-box;
      .label {
        text-align: left;
        height: 40px;
        line-height: 40px;
        font-size: $fs-medium-s;
      }
      .selected-content {
        padding: 12px;
        box-sizing: border-box;
        .selected-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: $fs-small-l;
          color: $color-grey;
          .second {
            margin-right: 19px;
          }
          .selected-item-name {
            height: 14px;
            line-height: 14px;
          }
          .remove {
            color: #ed6767;
            cursor: pointer;
          }
        }
      }
    }
  }
  .department-dialog-footer {
    display: flex;
    justify-content: center;
    padding-top: 16px;
  }
}
</style>